import MdxContent from "../../help/quality-home.mdx";

export function QualityHomePageHelpPage() {
  return <MdxContent />;
}
